import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "sample-item" }
const _hoisted_2 = ["disabled"]
const _hoisted_3 = { class: "actions" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Icon = _resolveComponent("Icon")
  const _component_el_skeleton_item = _resolveComponent("el-skeleton-item")
  const _component_el_skeleton = _resolveComponent("el-skeleton")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createVNode(_component_Icon, {
        width: "4rem",
        height: "4rem",
        icon: "file-blue"
      })
    ]),
    _createElementVNode("div", {
      class: "text",
      disabled: $props.file.removing
    }, [
      ($data.text)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(["name", {'failed': $props.file.failed}])
          }, _toDisplayString($data.text), 3 /* TEXT, CLASS */))
        : (_openBlock(), _createBlock(_component_el_skeleton, {
            key: 1,
            animated: ""
          }, {
            template: _withCtx(() => [
              _createVNode(_component_el_skeleton_item)
            ]),
            _: 1 /* STABLE */
          }))
    ], 8 /* PROPS */, _hoisted_2),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_Icon, {
        icon: "edit-03",
        class: "pointer",
        width: "2rem",
        height: "2rem",
        stroke: "var(--gray-600)",
        "stroke-width": "1",
        disabled: $props.file.removing || $props.file.failed,
        onClick: _cache[0] || (_cache[0] = _withModifiers($event => (_ctx.$emit('edit', $data.text)), ["stop"]))
      }, null, 8 /* PROPS */, ["disabled"]),
      _createVNode(_component_Icon, {
        icon: "trash-04",
        class: "pointer",
        width: "2rem",
        height: "2rem",
        stroke: "var(--gray-600)",
        "stroke-width": "1",
        disabled: $props.file.removing,
        onClick: _cache[1] || (_cache[1] = _withModifiers($event => (_ctx.$emit('delete', $props.file.id)), ["stop"]))
      }, null, 8 /* PROPS */, ["disabled"])
    ])
  ]))
}